<template>
  <div
    style="height: 100vh !important;background: rgba(255, 255, 255, 1);
 !important"
  >
    <div :class="getIsUploadsPage ? 'uploads-full-height' : ''">
      <template v-if="isShowHeader">
        <CommonHeader />
      </template>
      <router-view :class="getIsUploadsPage ? '' : 'full-height'" />
      <Loading :active="isLoading" />
      <obj id="obj-data-appid" :value="user.loanAppId"></obj>
      <obj id="obj-data-cif" :value="user.cif"></obj>
      <obj id="obj-data-channel" :value="user.channel"></obj>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    Loading: () => import("@/utils/Loading"),
    CommonHeader: () =>
      import("@/components/TemplateNewScreen/CommonHeader.vue"),
  },
  computed: {
    isShowHeader() {
      return (
        this.$route.name &&
        this.$route.name !== "NoAuthorized" &&
        this.$route.name !== "CallFromNext" &&
        this.$route.name !== "404" &&
        this.$route.name !== "LoginPage"
      );
    },
    isLoading() {
      return this.$store.getters.getIsLoading;
    },
    user() {
      return this.$store.getters.getUserData;
    },
    getHeight() {
      // return window.innerHeight == 0 ? 650 : window.innerHeight;
      return window.innerHeight;
    },
    getIsUploadsPage() {
      return (
        this.$route.name === "UploadPage" ||
        this.$route.name === "DocumentGroupPage" ||
        this.$route.name === "ListAccountPage"
      );
    },
  },
  created() {
    // var h = window.innerHeight;
    // if (h == 0) h = 650;
    // var styleModalOpen = document.createElement("style");
    // styleModalOpen.type = "text/css";
    // styleModalOpen.innerHTML =
    //   ".modal-backdrop, .modal-content-custom ,.modal-open , .modal , .full-height { height: " +
    //   h +
    //   "px  !important ; } " +
    //   " .router-height{ height: " +
    //   (h - 45) +
    //   "px !important;}";
    // document.getElementsByTagName("head")[0].appendChild(styleModalOpen);
    try {
      this.$callback.enterFullScreen();
    } catch (err) {
      //console.error(err);
    }
  },
};
</script>

<style>
@import "assets/styles/main.css";
</style>
<style>
.uploads-full-height {
  height: calc(95vh) !important;
}
.full-height {
   height: 95vh !important; 
}
</style>
